import { Command } from "@/app/common/base/command"
import {NpsResult} from "@/app/nps-feedback/entities/nps-result.entity";

export class NpsSubmitFollowUpCommand extends Command {
    public async run(resultId: string, answer: string) {
        const response = await this.client.post('/api/nps-feedback/follow-up', { resultId, answer })
        return response.asEntity(NpsResult)
    }
}
